import PortfolioPageLayout from "../PortfolioPageLayout";
import outtaWaxData from "../OuttaWax/outtaWaxData";

function OuttaWax() {
  return <PortfolioPageLayout {...outtaWaxData} />;
}

export default OuttaWax;